<div class="all-nominees-card">
  <div class="heading">
    <div class="heading-left">Nominee Details</div>
    <!-- <div class="heading-right" (click)="!(nominee.length > 0) && redirectToAddNominee()" 
                              [class.disabled]="nominee.length > 0"
                              [matTooltip]="nominee.length > 0 ? 'Nominee is already added' : ''">
     + <span>Add Nominee</span> </div> -->
  </div>
  <div class="loading-text" *ngIf="nominee.length === 0" (click)="redirectToAddNominee()" >

    <div class="row">
      <img src="../../../../assets/images/add-circle.png" alt="">
      <div class="col">
        <div class="head">Add Nominee</div>
        <div class="desc">Protect your loved ones add nominee details today!</div>
      </div>

    </div>
    <div>
      <img src="../../../../assets/images/arrow-right.png" alt="">
    </div>
  </div>
  <div class="nominees-grid" *ngIf="nominee.length > 0">
    <div class="single-nominee-card" *ngFor="let n of nominee">
      <div class="profile-pic">
        <!-- <img src="../../../../assets/images/adult-male-profile-pic.png" alt="" *ngIf="n.gender === 'Male'">
        <img src="../../../../assets/images/adult-female-profile-pic.png" alt="" *ngIf="n.gender === 'Female'"> -->
        <img [src]="'../../../../assets/images/'+ n.relationship +'.png'" alt="" >
      </div>
      <div class="details">
        <div class="nominee-name">{{n.name}}</div>
        <div class="nominee-about">{{n.relationship}} | {{n.age}} Years | {{n.gender}} | 100%</div>
      </div>
    </div>
  </div>
</div>